import type { FormInputData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";

export interface MaStRPersonFormValues {
  mastrNummer: string;
}

type MaStRPersonFormFieldData = {
  [K in keyof MaStRPersonFormValues]: FormInputData<MaStRPersonFormValues, K>;
};

export const MASTR_PERSON_FORM_FIELD_DATA: MaStRPersonFormFieldData = {
  mastrNummer: {
    name: "mastrNummer",
    label: "Marktstammdatenregister-Nummer des Marktakteurs",
    type: "text",
    required: true,
    helpText:
      "Es können nur juristische Personen mit der Marktfunktion Anlagenbetreiber importiert werden. " +
      "Die Marktstammdatenregisternummer für Anlagenbetreiber ist eine fünfzehnstellige Zeichenkette " +
      "und beginnt mit dem Präfix ABR.\n\nEin Beispiel ist: ABR954607370557"
  }
} as const;

export const MASTR_PERSON_DEFAULT_VALUES: MaStRPersonFormValues = {
  mastrNummer: ""
};
